import { User } from '@beatgig/api'
import { useMyAccount } from '@beatgig/auth-hooks'
import useArtistLikesPopupState from './use-artist-likes-state'

export default function useOpenArtistLikesPopup() {
  const [, setIsOpen] = useArtistLikesPopupState()
  const { data: account } = useMyAccount()

  return ({ close }: { close?: true } = {}) => {
    // if (User.hasOnboarded(account)) {
    //   User.refetchMyLikedArtistsSWR(account?.id)
    // }
    if (User.hasOnboarded(account)) {
      setIsOpen(!close)
    }
  }
}
